import React, { createContext, useContext, useState } from 'react';

const PaymentModeContext = createContext();

export const usePaymentMode = () => {
  const context = useContext(PaymentModeContext);
  if (!context) {
    throw new Error('usePaymentMode must be used within a PaymentModeProvider');
  }
  return context;
};

export const PaymentModeProvider = ({ children }) => {
  // 'pix' ou 'pagamento'
  const [paymentMode, setPaymentMode] = useState('pix');

  const togglePaymentMode = () => {
    setPaymentMode(prev => prev === 'pix' ? 'pagamento' : 'pix');
  };

  const value = {
    paymentMode,
    setPaymentMode,
    togglePaymentMode
  };

  return (
    <PaymentModeContext.Provider value={value}>
      {children}
    </PaymentModeContext.Provider>
  );
};
